<h1 matDialogTitle>{{ data.title }}</h1>
<div mat-dialog-content>
  <mat-card class="p-0">
    <form [formGroup]="produtoForm" (keydown.enter)="$event.preventDefault()">
      <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px" class="form-container">
        <!-- Código de Barras 1 -->
        <div fxFlex="50" fxFlex.lt-md="100" fxFlex.sm="50">
          <mat-form-field class="full-width">
            <mat-label>Código de Barras Nº 1</mat-label>
            <input
              [imask]="maskCodigoBarra"
              matInput
              name="codigobarra1"
              type="text"
              [formControl]="produtoForm?.controls['codigobarra1']!"
            />
            <button
              *ngIf="isMobileLayout()"
              #scanBarcodeBtn1
              mat-icon-button
              matSuffix
              type="button"
              [matTooltip]="'Ler código de barras'"
              (click)="onScanIconClick('codigobarra1', $event)"
            >
              <mat-icon>qr_code_scanner</mat-icon>
            </button>
          </mat-form-field>
          <div *ngIf="isMobileLayout() && !isCameraScannerSupported()" class="mobile-fallback-actions">
            <button mat-stroked-button type="button" (click)="pasteBarcodeFromClipboard('codigobarra1')">
              <mat-icon>content_paste</mat-icon>
              Colar
            </button>
            <button mat-stroked-button color="primary" type="button" (click)="validateBarcodeValue('codigobarra1')">
              <mat-icon>rule</mat-icon>
              Validar
            </button>
          </div>
          <!-- <ngx-barcode6 [bc-height]="40" [bc-format]="'EAN13'" [bc-value]="produtoForm?.controls['codigobarra1']?.value || ''" [bc-display-value]="true"></ngx-barcode6> -->
        </div>

        <!-- Código de Barras 2 -->
        <div fxFlex="50" fxFlex.lt-md="100" fxFlex.sm="50">
          <mat-form-field class="full-width">
            <mat-label>Código de Barras Nº 2</mat-label>
            <input
              [imask]="maskCodigoBarra"
              matInput
              name="codigobarra2"
              type="text"
              [formControl]="produtoForm?.controls['codigobarra2']!"
            />
            <button
              *ngIf="isMobileLayout()"
              mat-icon-button
              matSuffix
              type="button"
              [matTooltip]="'Ler código de barras'"
              (click)="onScanIconClick('codigobarra2', $event)"
            >
              <mat-icon>qr_code_scanner</mat-icon>
            </button>
          </mat-form-field>
          <div *ngIf="isMobileLayout() && !isCameraScannerSupported()" class="mobile-fallback-actions">
            <button mat-stroked-button type="button" (click)="pasteBarcodeFromClipboard('codigobarra2')">
              <mat-icon>content_paste</mat-icon>
              Colar
            </button>
            <button mat-stroked-button color="primary" type="button" (click)="validateBarcodeValue('codigobarra2')">
              <mat-icon>rule</mat-icon>
              Validar
            </button>
          </div>
          <!-- <ngx-barcode6 [bc-height]="40" [bc-format]="'EAN13'" [bc-value]="produtoForm?.controls['codigobarra2']?.value || ''" [bc-display-value]="true"></ngx-barcode6> -->
        </div>

        <!-- Código de Barras 3 -->
        <div fxFlex="50" fxFlex.lt-md="100" fxFlex.sm="50">
          <mat-form-field class="full-width">
            <mat-label>Código de Barras Nº 3</mat-label>
            <input
              [imask]="maskCodigoBarra"
              matInput
              name="codigobarra3"
              type="text"
              [formControl]="produtoForm?.controls['codigobarra3']!"
            />
            <button
              *ngIf="isMobileLayout()"
              mat-icon-button
              matSuffix
              type="button"
              [matTooltip]="'Ler código de barras'"
              (click)="onScanIconClick('codigobarra3', $event)"
            >
              <mat-icon>qr_code_scanner</mat-icon>
            </button>
          </mat-form-field>
          <div *ngIf="isMobileLayout() && !isCameraScannerSupported()" class="mobile-fallback-actions">
            <button mat-stroked-button type="button" (click)="pasteBarcodeFromClipboard('codigobarra3')">
              <mat-icon>content_paste</mat-icon>
              Colar
            </button>
            <button mat-stroked-button color="primary" type="button" (click)="validateBarcodeValue('codigobarra3')">
              <mat-icon>rule</mat-icon>
              Validar
            </button>
          </div>
          <!-- <ngx-barcode6 [bc-height]="40" [bc-format]="'EAN13'" [bc-value]="produtoForm?.controls['codigobarra3']?.value || ''" [bc-display-value]="true"></ngx-barcode6> -->
        </div>

        <!-- Código de Barras 4 -->
        <div fxFlex="50" fxFlex.lt-md="100" fxFlex.sm="50">
          <mat-form-field class="full-width">
            <mat-label>Código de Barras Nº 4</mat-label>
            <input
              [imask]="maskCodigoBarra"
              matInput
              name="codigobarra4"
              type="text"
              [formControl]="produtoForm?.controls['codigobarra4']!"
            />
            <button
              *ngIf="isMobileLayout()"
              mat-icon-button
              matSuffix
              type="button"
              [matTooltip]="'Ler código de barras'"
              (click)="onScanIconClick('codigobarra4', $event)"
            >
              <mat-icon>qr_code_scanner</mat-icon>
            </button>
          </mat-form-field>
          <div *ngIf="isMobileLayout() && !isCameraScannerSupported()" class="mobile-fallback-actions">
            <button mat-stroked-button type="button" (click)="pasteBarcodeFromClipboard('codigobarra4')">
              <mat-icon>content_paste</mat-icon>
              Colar
            </button>
            <button mat-stroked-button color="primary" type="button" (click)="validateBarcodeValue('codigobarra4')">
              <mat-icon>rule</mat-icon>
              Validar
            </button>
          </div>
          <!-- <ngx-barcode6 [bc-height]="40" [bc-format]="'EAN13'" [bc-value]="produtoForm?.controls['codigobarra4']?.value || ''" [bc-display-value]="true"></ngx-barcode6> -->
        </div>
      </div>

      <div *ngIf="isMobileLayout() && !isCameraScannerSupported()" class="mobile-fallback-note">
        Este navegador não suporta leitura automática por câmera. Use Colar + Validar.
      </div>

      <div *ngIf="mobileCameraScanning" class="mobile-scanner-panel">
        <div class="mobile-scanner-header">
          <div class="mobile-scanner-title">Leitura pela câmera (campo {{ getControlLabel(activeBarcodeControl) }})</div>
          <button mat-stroked-button color="warn" type="button" (click)="stopMobileBarcodeCamera()">
            <mat-icon>close</mat-icon>
            Fechar câmera
          </button>
        </div>
        <div class="mobile-scanner-video-wrap">
          <video #mobileBarcodeVideo autoplay playsinline muted></video>
        </div>
        <div class="mobile-scanner-tip">Aponte para o código de barras. O preenchimento será automático ao detectar.</div>
      </div>
    </form>
  </mat-card>
</div>
<mat-dialog-actions>
  <div fxFlex="100" class="action-buttons">
    <button
      mat-raised-button
      color="primary"
      [matTooltip]="'Salvar Lançamento'"
      (click)="this.save(); $event.preventDefault()"
    >
      <mat-icon>save</mat-icon> {{ "SAVE" | translate }}
    </button>
    <button mat-button color="warn" type="button" (click)="close()">
      <mat-icon>close</mat-icon> {{ "CLOSE" | translate }}
    </button>
  </div>
</mat-dialog-actions>